/**
 * サービスローンチ前の新規登録受付ゲート。feast-fe ADR 0059 / 0060。
 *
 * まだ正式ローンチ前であり、個人情報の取り扱い（予約プラポリ等）の法務レビュー完了後に
 * 新規登録の受付を開始する。本番（.env.prod）は `REACT_APP_SIGNUP_ENABLED=false` で受付を停止し、
 * 登録動線（LP の各 CTA・/register）を表示しない（ADR 0060）。stg / local は未設定（= 有効）でテスト可能。
 *
 * 判定は「明示的に 'false' のときだけ無効」。未設定・空・その他は有効（安全側で stg を止めない）。
 */
export const SIGNUP_ENABLED = process.env.REACT_APP_SIGNUP_ENABLED !== 'false';
